import { useState } from 'react';
import { App } from 'antd';
import { copyText, maskUserId } from '../../utils/clipboard';

/** Right-corner "ID ou…7290d ⧉" chip — one click copies the full user id.
 * Handy for support: users can hand you their id without digging in settings. */
export function UserIdChip({ userId }: { userId: string | null }) {
  const { message } = App.useApp();
  const [copied, setCopied] = useState(false);
  if (!userId) return null;

  const onCopy = async () => {
    const ok = await copyText(userId);
    if (ok) {
      setCopied(true);
      message.success('已复制用户 ID');
      window.setTimeout(() => setCopied(false), 1200);
    } else {
      message.error('复制失败，请长按手动复制');
    }
  };

  return (
    <button
      onClick={() => void onCopy()}
      title={`点击复制用户 ID：${userId}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        height: 22,
        padding: '0 8px',
        borderRadius: 5,
        border: '1px solid var(--border-soft, #e8e4dc)',
        background: 'var(--surface-1, #fff)',
        color: 'var(--ink-2, #5a5552)',
        fontSize: 10.5,
        fontFamily: 'var(--font-mono, monospace)',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      <span>ID {maskUserId(userId)}</span>
      <span style={{ color: copied ? '#2d6a4f' : 'var(--ink-3, #9a9590)' }}>
        {copied ? '✓' : '⧉'}
      </span>
    </button>
  );
}
